// @flow
import classnames from 'classnames';
import React from 'react';
import { makeStyles } from '@material-ui/styles';

import RoundedButton from '../../components/Buttons/RoundedButton';

const useStyles = makeStyles(theme => ({
  button: {
    position: 'relative',
    width: '100%',
    height: 56,
    paddingTop: 0,
    paddingRight: 20,
    paddingBottom: 0,
    paddingLeft: 20,
  },
}));

interface Props {
  children: Object;
  className?: string;
  color?: string;
}

const ConversationButton = ({ children, className, ...otherProps }: Props) => {
  const classes = useStyles();

  return (
    <RoundedButton className={classnames(classes.button, className)} {...otherProps} disableRipple>
      {children}
    </RoundedButton>
  );
};

export default ConversationButton;
